import React from 'react';
import { ApplicationStepWithNewContent } from '../../../../utils/ConfigDrivenFormUtils';
import { SectionIntro } from '../../../../openapi/atlantis';
import { ConfigDrivenIntroTemplate, EnumMap } from '../../../../types';
import { safeEnumMapGet } from '../../../../utils/EnumHelper';
import ConfigDrivenIntroContainer from '../ConfigDrivenIntroContainer';
import ConfigDrivenIntroContainerV2 from '../ConfigDrivenIntroContainerV2';

interface ConfigDrivenIntroWrapperProps {
  config: ApplicationStepWithNewContent<SectionIntro>;
  onStart: (stepId: string) => void;
  onNext: () => void;
}

interface ConfigDrivenIntroTemplateProps {
  config: ApplicationStepWithNewContent<SectionIntro>;
  onStart: (stepId: string) => void;
  onNext: () => void;
}

const ConfigDrivenIntroWrapper: React.FC<ConfigDrivenIntroWrapperProps> = ({
  config,
  onNext,
  onStart,
}) => {
  const CONFIG_DRIVEN_INTRO_CONTAINER: EnumMap<
    ConfigDrivenIntroTemplate,
    React.FC<ConfigDrivenIntroTemplateProps>
  > = {
    [ConfigDrivenIntroTemplate.TEMPLATE_1]: ConfigDrivenIntroContainer,
    [ConfigDrivenIntroTemplate.TEMPLATE_2]: ConfigDrivenIntroContainerV2,
    [ConfigDrivenIntroTemplate.TEMPLATE_3]: ConfigDrivenIntroContainerV2, // REZEN_AGENT_1 uses V2 component
  };

  const ConfigDrivenIntroComponent = safeEnumMapGet(
    CONFIG_DRIVEN_INTRO_CONTAINER,
    config?.content?.style?.template as unknown as ConfigDrivenIntroTemplate,
    CONFIG_DRIVEN_INTRO_CONTAINER[ConfigDrivenIntroTemplate.TEMPLATE_1],
  );

  return (
    <ConfigDrivenIntroComponent
      config={config}
      onStart={onStart}
      onNext={onNext}
    />
  );
};

export default ConfigDrivenIntroWrapper;
